import { DateTime } from 'luxon'
import { QuoteReservation } from '@/models/quote'
import { Service } from '@/models/service'
import { timeScheduleSlice } from '@/store/timeScheduleSlice'
import { useAppDispatch } from '../store'

interface Props {
  isEdit: boolean
  reservation?: QuoteReservation | null
  service: Service
}

export function useTriggerClick(props: Props) {
  const dispatch = useAppDispatch()

  function onTriggerClick() {
    if (props.isEdit && props.reservation) {
      if (props.reservation.boughtServices[props.service.serviceId]) {
        const boughtServices =
          props.reservation.boughtServices[props.service.serviceId]

        const days = new Set<number>()
        Object.values(boughtServices).forEach((boughtService) => {
          boughtService.days.forEach((day) => {
            const isoDate = DateTime.fromSeconds(day, {
              locale: 'utc',
            }).toISODate()
            days.add(DateTime.fromISO(isoDate).toMillis())
          })
        })
        dispatch(timeScheduleSlice.actions.setSelectedDays(Array.from(days)))

        Object.values(boughtServices).forEach((boughtService) => {
          dispatch(
            timeScheduleSlice.actions.changeTimeScheduleAmount({
              amount: boughtService.bought,
              timeSchedule: boughtService.timeSchedule,
            })
          )
        })
      }
    }
    dispatch(timeScheduleSlice.actions.setService(props.service))
  }

  return {
    onTriggerClick,
  }
}
